module.exports = __webpack_public_path__ + "static/media/MCT-Slider-mobile-4.4b279285.jpg";